import React, { useEffect, useState } from "react";
import { pastOrderListApi } from "../../redux/apis/table-apis";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const PastOrderList = () => {
  const [orders, setOrders] = useState([]);
  const [refreshing, setRefreshing] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setRefreshing(true);
    try {
      const res = await pastOrderListApi();
      if (res.status === 200) {
        setOrders(res.data.data.orders);
      }
    } catch (error) {
      console.error(error, "error");
    }
    setRefreshing(false);
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 bg-white border-b border-gray-200 shadow-sm">
        <button
          onClick={() => navigate('/pos/tables')}
          className="p-2 rounded hover:bg-gray-100"
        >
          ←
        </button>
        <h1 className="text-lg font-bold text-gray-900">Past Order List</h1>
        <div className="w-6" />
      </div>

      {/* Order List */}
      <div className="flex-1 overflow-y-auto pb-6">
        {refreshing ? (
          <div className="flex justify-center py-10 text-gray-500">
            Loading...
          </div>
        ) : orders.length === 0 ? (
          <div className="flex justify-center py-10 text-gray-500">
            No past orders found
          </div>
        ) : (
          <div className="space-y-4 px-3 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {orders.map((item) => (
              <div
                key={item.id}
                onClick={() =>
                  navigate(`/pos/past-order-details/${item.id}`)
                }
                className="bg-white rounded-xl shadow hover:shadow-md transition cursor-pointer p-4"
              >
                <h2 className="text-lg font-bold text-gray-900 mb-2">
                  Invoice #{item.invoice_number}
                </h2>
                <p className="text-sm text-gray-600">
                  Table:{" "}
                  <span className="font-semibold text-gray-900">
                    {item.restaurant_table_id}
                  </span>
                </p>
                <p className="text-sm text-gray-600">
                  Order Type:{" "}
                  <span className="font-semibold text-gray-900">
                    {item.order_type}
                  </span>
                </p>
                <p className="text-sm text-gray-600">
                  Payment:{" "}
                  <span className="font-semibold text-gray-900">
                    {item.payment_method}
                  </span>
                </p>

                <div className="flex justify-between text-sm mt-2">
                  <span className="text-gray-600">Subtotal:</span>
                  <span className="font-semibold text-gray-900">
                    ₹{item.total_before_tax}
                  </span>
                </div>

                <div className="flex justify-between text-sm mt-1">
                  <span className="text-gray-600">CGST:</span>
                  <span className="font-semibold text-gray-900">
                    ₹{item.cgst}
                  </span>
                </div>

                <div className="flex justify-between text-sm mt-1">
                  <span className="text-gray-600">SGST:</span>
                  <span className="font-semibold text-gray-900">
                    ₹{item.sgst}
                  </span>
                </div>

                <div className="flex justify-between text-sm mt-1">
                  <span className="text-gray-600">Total:</span>
                  <span className="font-semibold text-gray-900">
                    ₹{item.total_after_tax_with_discount_parcel_charge}
                  </span>
                </div>

                <p className="text-xs text-gray-500 mt-3 text-right">
                  {moment.parseZone(item.updatedAt).format(
                    "DD-MMM-YYYY hh:mm a"
                  )}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PastOrderList;
